import { useState } from '@noshiro/preact-utils';
import { IList } from '@noshiro/ts-utils';
import { useEffect, useMemo, useRef } from 'preact/hooks';
import { ResizeObserver as CustomResizeObserver } from 'resize-observer';
export const useResizeObserverRef = (setSize) => {
    const rootResizeObserver = useMemo(() => 
    // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
    new CustomResizeObserver((entries) => {
        if (IList.isNonEmpty(entries)) {
            setSize(entries[0].contentRect);
        }
    }), [setSize]);
    const targetElRef = useRef(null);
    useEffect(() => {
        const el = targetElRef.current;
        if (el !== null) {
            rootResizeObserver.observe(el);
        }
        return () => {
            if (el !== null) {
                rootResizeObserver.unobserve(el);
            }
            rootResizeObserver.disconnect();
        };
    }, [targetElRef, rootResizeObserver]);
    return targetElRef;
};
export const useResizeObserver = (defaultSize) => {
    const { state: size, setState: setSize } = useState(defaultSize !== null && defaultSize !== void 0 ? defaultSize : { width: 0, height: 0, left: 0, top: 0 });
    const targetElRef = useResizeObserverRef(setSize);
    return [size, targetElRef];
};
